import { selectSettingClientsState } from 'modules/settings/submodules/clients/store/selectors';
import { IStore } from 'store/configureStore';

const selectCreateModalState = (state: IStore) =>
    selectSettingClientsState(state).assignmentsReportData.createAssignmentMetaData;
export const selectIsOpenedCreateAssignmentMetaModal = (state: IStore) => selectCreateModalState(state).modalIsOpen;
export const selectIsCreatingAssignmentMeta = (state: IStore) => selectCreateModalState(state).isCreating;
